import React, { useMemo } from 'react';
import { accountEntityReferenceAutocompletePersonOnlyFilter } from '../../../../../person/person';
import ContactFormWidget from '../../../../../production/resource/orders/editor/resourceOrderApprovalsStep/ContactFormWidget';
import { SECURITY_ACTIONS } from '../../../../auth/Security';
import type { SecuredActionType } from '../../../../components/ActionType';
import EditablePanel, { type EditablePanelProps } from '../../../../components/EditablePanel';
import { APPROVAL_EDITABLE_PANEL_HEADER_SX } from '../../../constants';
import { useCreateApprovalContext } from '../../hooks/useCreateApprovalContext';
import CreateApprovalFormEditablePanelHeader from '../CreateApprovalFormEditablePanelHeader';
import ApprovalStrategySelect from './ApprovalStrategySelect';

export type ApprovalApproversFormFieldsProps = Pick<EditablePanelProps, 'isCollapsable' | 'defaultCollapsed'>;

export default function ApprovalApproversFormFields({
    isCollapsable,
    defaultCollapsed
}: ApprovalApproversFormFieldsProps) {
    const { isSavingApprovalInput } = useCreateApprovalContext();

    const approversActions = useMemo<SecuredActionType[]>(
        () => [
            {
                securityAction: SECURITY_ACTIONS.EDIT,
                component: (
                    <ApprovalStrategySelect disabled={isSavingApprovalInput} sx={{ mr: isCollapsable ? 1 : 0 }} />
                )
            }
        ],
        [isCollapsable, isSavingApprovalInput]
    );

    return (
        <EditablePanel
            Header={<CreateApprovalFormEditablePanelHeader titleToken={'approval.approvers.header'} />}
            isCollapsable={isCollapsable}
            defaultCollapsed={defaultCollapsed}
            headerSx={APPROVAL_EDITABLE_PANEL_HEADER_SX}
            securedActions={approversActions}
        >
            <ContactFormWidget
                name={'approverContacts'}
                labelToken="common.search.for.people"
                filter={accountEntityReferenceAutocompletePersonOnlyFilter}
                disabled={isSavingApprovalInput}
            />
        </EditablePanel>
    );
}
